import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import PropTypes from 'prop-types'
import '../styles/UnsavedChangesPopup.scss'

class UnsavedChangesPopup extends React.Component {
  constructor(props) {
    super(props)
    this.player = React.createRef()
    this.state = {}
  }

  render() {
    return (
      <Modal
        centered
        show={this.props.isOpen}
        className='unsavedChangesPopup'
        onHide={() => this.props.onClose()}
      >
        <Modal.Header>Unsaved Changes Alert</Modal.Header>
        <Modal.Body>
          <div>You have unsaved changes for the item below:</div>
          <div>{this.props.unsavedItemNames.join(', ')}</div>
          <div className='__buttons'>
            <Button onClick={this.props.onSave} className='__button'>
              Save
            </Button>
            <Button onClick={this.props.onDiscard} className='__button'>
              Discard
            </Button>
            <Button onClick={this.props.onCancel} className='__button'>
              Cancel
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    )
  }
}

UnsavedChangesPopup.propTypes = {
  unsavedItemNames: PropTypes.array,
  onSave: PropTypes.func,
  onDiscard: PropTypes.func,
  onCancel: PropTypes.func,
  isOpen: PropTypes.bool
}

export default UnsavedChangesPopup
